export const DiscountReviewResources = {
    panelTitle: "Opinie o promocji {0}",
    remark: " Napisz pierwszą recenzję",
    remarkComment: "Napisz recenzję",
    momentText: "Opublikowano",
    viewMoreText: "Pokaż więcej opinii",
};
